import type { Page } from '../types';

// URL のパス階層からツリー構造を組む。
// 例: /about/ → { '': { 'about': { '': leaf } } }
export interface TreeNode {
  // このノードに対応する URL（ある場合）
  page?: Page;
  // 配下の子ノード
  children: Map<string, TreeNode>;
  // 配下の総ページ数（自身含む）
  totalPages: number;
}

// pages からツリーを組む。
// primaryHost が指定されていて、ページのホストが起点と異なる場合は `[host]` を最上位セグメントに
// 挿入して別ツリーとして分離する。これにより、同じ pathname を持つ別ホストのページ
// (例: https://example.com/ と https://sub.example.com/) がルートを上書きする事故を防ぐ。
export function buildTree(pages: Page[], primaryHost?: string): TreeNode {
  const root: TreeNode = { children: new Map(), totalPages: 0 };

  for (const page of pages) {
    let url: URL;
    try {
      url = new URL(page.url);
    } catch {
      continue;
    }
    const segments: string[] = [];
    if (primaryHost && url.host !== primaryHost) {
      segments.push(`[${url.host}]`);
    }
    segments.push(...url.pathname.split('/').filter((s) => s.length > 0));

    let node = root;
    for (const seg of segments) {
      let child = node.children.get(seg);
      if (!child) {
        child = { children: new Map(), totalPages: 0 };
        node.children.set(seg, child);
      }
      node = child;
    }
    node.page = page;
  }

  // totalPages を再帰的に計算
  computeTotals(root);
  return root;
}

function computeTotals(node: TreeNode): number {
  let total = node.page ? 1 : 0;
  for (const child of node.children.values()) {
    total += computeTotals(child);
  }
  node.totalPages = total;
  return total;
}
